import classnames from 'classnames';
import {hasFlag} from 'helpers/bitwise';
import React, {useEffect, useState} from 'react';
import {Trans} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Link, useRouteMatch} from 'react-router-dom';
import {
  ROUTE_STANDALONE_FEED,
  ROUTE_STANDALONE_FEEDBACK,
  ROUTE_STANDALONE_SETTINGS,
} from 'router/routes.const';
import {generalSelector} from 'selectors';
import {authService} from 'services';
import {F_PAGE_FEED, F_PAGE_FEEDBACK} from 'services/project';
import ModalIdentify from '../ModalIdentify';
import './_Styles.scss';

const TAB_FEED = 'FEED';
const TAB_FEEDBACK = 'FEEDBACK';

const TopNav = ({hideOnMobile}) => {
  const jimer = useSelector((state) => generalSelector.getJimer(state));
  const project = useSelector((state) => generalSelector.getProject(state));
  const hideTopNav = useSelector((state) =>
    generalSelector.getHideTopNav(state)
  );

  const [showModalIdentify, setShowModalIdentify] = useState(false);
  const [activeTab, setActiveTab] = useState(null);

  const {path} = useRouteMatch();

  useEffect(() => {
    const isActive = (paths) => {
      return [].concat(paths).includes(path);
    };

    if (isActive([ROUTE_STANDALONE_FEED])) {
      setActiveTab(TAB_FEED);
    } else if (isActive([ROUTE_STANDALONE_FEEDBACK])) {
      setActiveTab(TAB_FEEDBACK);
    }
  }, [path]);

  const handleShowHideModalIdentify = (show = !showModalIdentify) => {
    setShowModalIdentify(show);
  };

  const identifiedLetter =
    authService.isIdentified(jimer) === true
      ? jimer.personalEmail != null
        ? jimer.personalEmail.slice(0, 1)
        : jimer.externalEmail.slice(0, 1)
      : null;

  const showFeedback = hasFlag(F_PAGE_FEEDBACK, project.portalContentFlags);
  const showFeed = hasFlag(F_PAGE_FEED, project.portalContentFlags);
  const allShow = [showFeed, showFeedback];

  const sectionsStr = project.portalSectionOrder || 'feed;feedback';
  const sections = sectionsStr.split(';');
  const filteredSections = sections.filter((s) => {
    if (showFeedback === false && s === 'feedback') {
      return false;
    }
    if (showFeed === false && s === 'feed') {
      return false;
    }
    return true;
  });

  const firstSection = filteredSections[0];

  const renderNav = () => {
    return (
      <>
        {filteredSections.map((s, index) => {
          if (s === 'feed') {
            return (
              <Link
                to={ROUTE_STANDALONE_FEED}
                className={classnames('item', {
                  'is-active': activeTab === TAB_FEED,
                })}>
                {index === 0 && <i className="icon-feed" />}
                Feed
              </Link>
            );
          }
          if (s === 'feedback') {
            return (
              <Link
                to={ROUTE_STANDALONE_FEEDBACK}
                className={classnames('item', {
                  'is-active': activeTab === TAB_FEEDBACK,
                })}>
                {index === 0 && <i className="icon-feed" />}
                <Trans i18nKey="others.topNavGiveFeedback" />
              </Link>
            );
          }
          return <></>;
        })}
      </>
    );
  };

  return (
    <div
      className={classnames('standalone-home-top-nav', {
        'is-hidden-mobile': hideOnMobile === true,
        'has-only-one-item': filteredSections.length <= 1,
        'no-padding-top': hideTopNav === true,
      })}>
      <div className="content">
        {hideTopNav === false && (
          <div className="box left">
            <Link
              to={
                firstSection === 'feed'
                  ? ROUTE_STANDALONE_FEED
                  : firstSection === 'feedback'
                  ? ROUTE_STANDALONE_FEEDBACK
                  : '#'
              }
              className="project-wrapper">
              {project.portalLogoUrl != null ? (
                <div className="project-logo">
                  <img
                    src={project.portalLogoUrl}
                    alt={`${project.name} logo`}
                  />
                </div>
              ) : (
                <div className="project-name">{project.name}</div>
              )}
            </Link>
          </div>
        )}
        {allShow.filter((s) => s === true).length > 1 && (
          <div className="box item-wrapper middle max-width-600">
            {renderNav()}
          </div>
        )}
        {hideTopNav === false && (
          <div className="box right">
            {identifiedLetter != null ? (
              <Link to={ROUTE_STANDALONE_SETTINGS} className="avatar">
                {identifiedLetter}
              </Link>
            ) : (
              <div
                className="avatar not-identified"
                onClick={() => handleShowHideModalIdentify(true)}
              />
            )}
          </div>
        )}
      </div>
      <ModalIdentify
        isOpen={showModalIdentify}
        onRequestClose={() => handleShowHideModalIdentify(false)}
      />
    </div>
  );
};

export default TopNav;
